import React from 'react';
import { objectUtils } from '@codametrix/ui-common';
import classnames from 'classnames';

export type NotesSidebarProps = {
  activeNote: CMxCommonApp.DecoratedNote;
  documentMetadata?: CMxAPI.DocumentMetadata[];
  onSelect?: (docMetadata: CMxAPI.DocumentMetadata) => void;
};

const DEFAULT_PROPS = {
  documentMetadata: [],
  onSelect: (docMetadata: CMxAPI.DocumentMetadata) => {}
};

const DocCategories: {
  [key: string]: string;
} = {
  DFT: 'DFTs',
  DFT_IN: 'Inbound DFTs',
  DFT_OUT: 'Outbound DFTs',
  NTE: 'Notes',
  NOTE: 'Notes',
  HL7: 'HL7 Messages',
  DFT_EHR: 'DFT EHRs'
};

const NotesSidebar = (passed: NotesSidebarProps) => {
  const props = { ...DEFAULT_PROPS, ...passed };
  const { documentMetadata, onSelect, activeNote } = props;

  //@ts-ignore
  const prepped = (documentMetadata || []).map(doc => {
    // Document categories are not named for end users.
    // Supplant with our own category names, shown above.
    // But if someone adds a document category we don't want to
    // blow up.
    return {
      ...doc,
      documentCategory:
        DocCategories[doc.documentCategory] || doc.documentCategory
    };
  });
  const docGroups = objectUtils.groupBy(prepped, 'documentCategory');

  const sortDocs = (a: string, b: string) => {
    if (a === b) return 0;
    if (a === 'HL7 Messages' || a === 'Notes') return -1;
    if (b === 'HL7 Messages' || b === 'Notes') return 1;

    if (a < b) return -1;
    if (a > b) return 1;
    return 0;
  };

  const groups = Object.keys(docGroups)
    .sort(sortDocs)
    .map(key => {
      const docs = objectUtils.get(docGroups, key) ?? [];

      const items = docs.map((document: any, idx: number) => {
        const onClick = (event: React.MouseEvent) => {
          event.preventDefault();
          onSelect(document);
        };

        const isActive = activeNote.id === document.id;
        const styleClasses = classnames([
          { 'is-active': isActive },
          'sidebar-link'
        ]);

        return (
          <li key={document.documentGuid.uuid} className={styleClasses}>
            <a data-testid="listlink" href="#/something" onClick={onClick}>
              <span className="document-name" data-testid="document-name">
                {document.documentName ?? 'Name N/A'}
              </span>
               <span className="document-description">
                  {document.documentDescription}
              </span>

              <span className="document-status">{document.documentStatus}</span>
            </a>
          </li>
        );
      });
      return (
        <div key={key}>
          <span className="note-doc-category" data-testid="note-doc-category">
            {docs[0].documentCategory}
          </span>
          <ul className="note-sidebar-list">{items}</ul>
        </div>
      );
    });

  return (
    <div className="notes-sidebar" data-testid="notes-sidebar">
      <div className="sidebar-fixed">
        <div className="sidebar-container">
          <div className="sidebar-inner">{groups}</div>
        </div>
      </div>
    </div>
  );
};

export { NotesSidebar };
